/**
 * Creates a dynamic heading element.
 * @param {string} [tag] - HTML heading tag (h1–h6); defaults to h1 or h2 based on isSub
 * @param {string|null|undefined} content - Heading text
 * @param {boolean} [isSub] - If true, uses h2 and "subtitle" class; otherwise h1 and "title"
 * @returns {JSX.Element|null}
 */
const createHeading = (tag, content, isSub) => {
    if (content === undefined || content === null) {
        return null;
    }
    const defaultTag = isSub ? "h2" : "h1";
    const Tag = (tag || defaultTag).toLowerCase();
    const className = isSub ? "subtitle" : "title";
    return <Tag className={className}>{content}</Tag>;
};

export default createHeading;
